import "./amplify-config.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.js";
import { ProgressProvider } from "./Context/ProgressContextClean.js";
import { ConnectedClientProvider } from "./ui-components/ConnectedClientContext.js";

function AppWrapper() {
  return (
    <BrowserRouter>
      <ConnectedClientProvider>
        <ProgressProvider>
          <App />
        </ProgressProvider>
      </ConnectedClientProvider>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
);
